import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgElevatorBucketZForm = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 430,
	height: 250,
	viewBox: "0 0 430.0 250.0",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M 0.0 180.0 L 180.0 180.0 L 180.0 0.0 L 430.0 0.0 L 430.0 70.0 L 250.0 70.0 L 250.0 250.0 L 0.0 250.0 Z",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 195,
			y: 35,
			width: 40,
			height: 180,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 215,
			y: 15,
			width: 180,
			height: 40,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 35,
			y: 195,
			width: 180,
			height: 40,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 395,
			cy: 35,
			rx: 20,
			ry: 20,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 35,
			cy: 215,
			rx: 20,
			ry: 20,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 215,
			cy: 35,
			rx: 20,
			ry: 20,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 215,
			cy: 215,
			rx: 20,
			ry: 20,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		})
	]
});
export default SvgElevatorBucketZForm;
